export const PAGES = {
  rootPage: 'assignments',
  loginPage: 'login',
  assignmentsPage: 'assignments',
  pinPage: 'pin',
  passwordPage: 'password',
  projectsPage: 'projects',
  projectDetailsPage: 'details',
  projectProductsPage: 'products',
  phasePage: 'phase',
  activitiesPage: 'activities',
  settingsPage: 'settings'
};
